import axios from "./axiosService";
import services from "./base";
import { DateTimeFormat } from "./common";

const dateService = {
  getAllDates: async () => {
    try {
      const response = await axios.get(services.urlDate + "/");
      return response.data.map((item) => ({
        ...item,
        created_date: DateTimeFormat(item.created_date),
        arranged_date: DateTimeFormat(item.arranged_date),
      }));
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  getDatebyExpedienteId: async (id) => {
    try {
      const response = await axios.get(services.urlDate + "/" + id, { params: { id } });
      return response.data.map((item) => ({
        ...item,
        created_date: DateTimeFormat(item.created_date),
        arranged_date: DateTimeFormat(item.arranged_date),
      }));
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  createDate: async (obj) => {
    try {
      const response = await axios.post(services.urlDate, { obj });
      if (response.data.error) {
        return response.data.error;
      } else {
        return response.status;
      }
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  deleteDateById: async (id) => {
    try {
      const response = await axios.delete(services.urlDate + "/" + id, { params: { id } });
      if (response.status === 200) {
        return { success: true, message: response.data.message };
      } else {
        return { success: false, message: "No se pudo eliminar el registro" };
      }
    } catch (error) {
      const status = error.response?.status || 500;
      const message = error.response?.data?.error || "Error desconocido";
      return { success: false, message: `Error (${status}): ${message}` };
    }
  },
};

export default dateService;
